<script setup lang="ts">
import { reactive, ref, watch, onMounted, onUnmounted, onBeforeUnmount } from 'vue'
import { ElMessage, type FormInstance, type FormRules } from 'element-plus'
import emitter from '@/stores/mitt'
import { Data } from '@/stores/data'
import { Utill } from '@/stores/Utill'
import { HTTP } from '@/network/http'
import { useRouter, useRoute } from 'vue-router'
import { muban } from '@/mocks/muban'
import type { Muban } from '@/types/muban'
import { moduleList } from '@/stores/StaticText'
import { Base64 } from 'js-base64'

let def = defineProps({
  dialogVisible: {
    type: Boolean,
    default: false
  },
  dialogType: {
    type: String,
    default: ''
  },
  dialogTitle: {
    type: String,
    default: ''
  }
})

const $emit = defineEmits(['submitClick', 'closeDialog', 'submitMembershipForm'])
let defaultDialogVisible = ref(def.dialogVisible)
let loginDialogVisible = ref(def.dialogVisible)
let feedbackDialogVisible = ref(def.dialogVisible)

//测试数据
const TemplateImgList: Array<Muban> = muban
let selePttData = ref<Muban>(TemplateImgList[0])

interface MembershipForm {
  code: string
  bookId: string | null

}

const membershipForm = ref<MembershipForm>({
  code: '',
  bookId: null,
})
const ruleFormRef = ref<FormInstance>()
const rules = reactive<FormRules<MembershipForm>>({
  code: [{ required: true, message: '请输入正确的激活码', trigger: 'blur' }],
  bookId: [{ required: true, message: '请选择学段', trigger: 'change' }],
})



const phaseList = ref<any[]>([])//学段
const subjectList = ref<any[]>([])//学科
let bookList = ref([]);
const qrcodeImg = ref('')
const key = ref('')
const router = useRouter()
let intervalId = null // 用于存储定时器的ID
let privacyInterval = null // 用于存储隐私协议定时器的ID

//验证码倒计时

let btnTimer = null

const isClickSubmit = ref(false)

let moduleDataList = moduleList
let selectModuleData = ref<any>(moduleList[0])

const feedbackForm = ref<any>({
  moduleName: '教案生成',
  questions: [],
  detailedQuestion: '',
  phone: ''
})
const isCheckForm = ref(false)


onMounted(() => {
  getSubjectList()
  if (def.dialogType == 'login' && def.dialogVisible) {
    getQrcode()
    privacyInterval = setInterval(checkIsShowAgreeStatus, 1000)
  }
  if (def.dialogType == 'experience') {
    if (def.dialogTitle == '请完成设置') {
      membershipForm.value = {
        code: '',
        bookId: null,
      }
    } else {
      membershipForm.value = {
        code: (Data.currUserBook.value && Data.currUserBook.value.code) ? Data.currUserBook.value.code : '',
        bookId: (Data.currUserBook.value && Data.currUserBook.value.id) ? Data.currUserBook.value.id : null,
      }
    }

  }
})

onUnmounted(() => {
  if (intervalId) {
    clearInterval(intervalId)
  }
  if (privacyInterval) {
    clearInterval(privacyInterval)
  }
  if (btnTimer) {
    clearInterval(btnTimer)
  }
})

const submitMembershipForm = async (formEl: FormInstance | undefined) => {
  console.log(formEl)
  if (!formEl) return

  await formEl.validate((valid, fields) => {
    if (valid) {
      // console.log(membershipForm.value)
      activationCode();

      // $emit('submitMembershipForm', membershipForm.value)
    } else {
      console.log('error submit!', fields)
      ElMessage.error('必填项还没完成呢，请检查一下')
    }
  })
}


function closeDialog() {
  if (intervalId) {
    clearTimeout(intervalId)
    intervalId = null
  }
  console.log(intervalId)
  defaultDialogVisible.value = false
  loginDialogVisible.value = false
  feedbackDialogVisible.value = false
  $emit('closeDialog', def.dialogType)
}
async function activationCode() {
  if (def.dialogTitle == '修改设置') {
    HTTP.updateActivationCode(membershipForm.value).then(async (res) => {
      if (res.code == 200) {
        await Utill.checkRemaining()
        defaultDialogVisible.value = false;
        ElMessage.success('修改成功');

      }
      // console.log(res)

    })
  } else {
    HTTP.activationCode(membershipForm.value).then(async (res) => {
      if (res.code == 200) {
        await Utill.checkRemaining()
        defaultDialogVisible.value = false;
        ElMessage.success('绑定成功');

      }
      // console.log(res)

    })
  }

}
function getSubjectList() {
  if (Data.bookData.value && Data.bookData.value.length > 0) {
    phaseList.value = Data.bookData.value;
    return;
  }
  HTTP.getBook().then((res) => {
    console.log(res)
    Data.bookData.value = res.data.records;
    phaseList.value = res.data.records
  })
}

// 监听学段的值改变调用的函数
// watch(
//   () => membershipForm.value.bookId,
//   (newValue, oldValue) => {
//     console.log(phaseList.value)
//     for (let item in phaseList.value) {
//       // if(newValue){
//       subjectList.value = []
//       if (phaseList.value[item].id == membershipForm.value.bookId) {
//         subjectList.value = phaseList.value[item].children
//         console.log('>phaseList.value[item]>>>>', phaseList.value)
//         return
//       }
//     }
//   }
// )

async function submitTemplate() {
  await Utill.checkRemaining()
  console.log('剩余次数', Data.userInfo.value?.remaining)
  if (Data.lv.value == 0) {
    //新用户
    console.log('新用户总剩余次数', Data.lastCanCountByUser.value)
    if (Data.lastCanCountByUser.value == 0) {

      Utill.showMemberOrActivityDialog()
      return
    }
  } else {
    //非新用户
    console.log('今日剩余次数', Data.userInfo.value?.remaining)
    if (Data.userInfo.value?.remaining == 0) {
      ElMessage({
        message: '今日您的使用次数已用完',
        type: 'warning',
        plain: true
      })
      return
    }
  }
  $emit('submitClick', selePttData.value)
  isClickSubmit.value = false
  defaultDialogVisible.value = false
  emitter.emit('submit-pptTemplate', selePttData.value)
}

function switchTemplate(item: Muban) {
  selePttData.value = item
}

function getQrcode() {
  HTTP.getQrCode()
    .then((res) => {
      console.log(res)
      if (res.code == 200) {
        qrcodeImg.value = res.data.url
        key.value = res.data.key
        startCheckingLoginStatus()
      }
    })
    .catch((error) => {
      console.error('接口调用出错:', error)
    })
}

const startCheckingLoginStatus = async () => {
  if (intervalId !== null) {
    clearTimeout(intervalId)
  }
  if (loginDialogVisible.value == false) {
    console.log('startCheckingLoginStatus', 1)
    return
  }
  intervalId = setTimeout(async () => {
    try {
      const response = await HTTP.wxLoginStatus(key.value)
      if (response.code === 200 && response.data) {
        // 登录成功
        clearTimeout(intervalId)
        intervalId = null
        Data.userInfo.value = response.data
        Data.token.value = response.data.token
        Data.isLogin.value = true
        Data.lv.value = response.data.lv

        if (response.data.userBook && response.data.userBook.length > 0) {
          Data.userBook.value = response.data.userBook;
          Data.lv.value = 2;
          Data.currUserBook.value = response.data.userBook[0];

        }
        closeDialog()
        if (Data.lv.value == 0) {
          console.log('新用户')
          setTimeout(() => {//这里延时100是因为closeDialog关闭和打开太近
            Utill.showBookDialog(null);
          }, 100)
        }
        console.log(Data.userInfo.value.token)

        ElMessage.success('登录成功')
        localStorage.setItem('userInfoToken', response.data.token)
        localStorage.setItem('userInfo', JSON.stringify(response.data))
        // router.push('application')
        Data.myFileType.value = {
          id: 0,
          name: '教案',
          resourceType: 'lesson',
          iconImg: 'icons/teachPlain-icon.png',
          exampleImg: 'icons/file-lesson-img.png',
          itemWidth: 172
        }
      } else {
        // 如果未登录成功，则2秒后再次检查
        startCheckingLoginStatus()
      }
    } catch (error) {
      console.error('接口调用出错:', error)
      if (error.code === 1001) {
        console.log('二维码失效，重新获取')
        getQrcode()
      }
      startCheckingLoginStatus()
    }
  }, 2000)
}

//绑定邀请关系
function getRelationshipBinding() {
  console.log(Data.isActivityOpen.value)
  if (Data.isActivityOpen.value) {
    // 1031 实物活动
    const data = {
      openid: Data.userInfo.value?.openid,
      inviter: Data.inviteOpenId.value
    }
    HTTP.getActInitData(data as any)
      .then((res) => {
        console.log(res)
        if (res.code == 200) {
          console.log(res)
          if (res.descb) {
            ElMessage.success(res.descb)
          }
        }
      })
      .catch((error) => {
        console.error('接口调用出错:', error)
      })
    return
  } else {
    //日常拉新活动 1015拉新活动（已过期）
    HTTP.getRelationshipBinding(Data.inviteOpenId.value).then((res) => {
      console.log(res)
      if (res.code == 200) {
        console.log(res)
        ElMessage.success('助力成功')
      }
    })
      .catch((error) => {
        console.error('接口调用出错:', error)
      })
  }
}
function gotoAgreeMentPage() {
  Data.isShowAgree.value = true
  Utill.gotoAgreeMentPage()
}
function checkIsShowAgreeStatus() {
  if (!Data.isShowAgree.value) {
    clearInterval(privacyInterval)
  }
}

function switchModule(item: any) {
  selectModuleData.value = item
  feedbackForm.value.moduleName = item.name
  feedbackForm.value.questions = []
}

function selectQuestions(item: any) {
  console.log(item)
  if (feedbackForm.value.questions.includes(item.name)) {
    feedbackForm.value.questions = feedbackForm.value.questions.filter(
      (selectedItem) => selectedItem != item.name
    )
  } else {
    feedbackForm.value.questions.push(item.name)
  }
  console.log(feedbackForm.value.questions)
}

function submitFeedback() {
  isCheckForm.value = true
  if (feedbackForm.value.moduleName == '') {
    ElMessage.error('必填项还没完成呢，请检查一下')
    return
  }
  if (feedbackForm.value.questions.length == 0) {
    ElMessage.error('必填项还没完成呢，请检查一下')
    return
  }
  if (feedbackForm.value.questions.includes('其他') && feedbackForm.value.detailedQuestion == '') {
    ElMessage.error('必填项还没完成呢，请检查一下')
    return
  }
  console.log(feedbackForm.value)
  feedbackForm.value.questions = JSON.stringify(feedbackForm.value.questions)
  console.log(feedbackForm.value)
  HTTP.submitFeedback(feedbackForm.value as any).then((res) => {
    console.log(res)
    if (res.code == 200) {
      closeDialog()
      console.log(res)
      let dialogData = {
        show: true,
        tipDialogType: 'feedback',
        tipDialogTitle: '收到！'
      }
      isCheckForm.value = false
      console.log(dialogData)
      emitter.emit('show-tipDialog', dialogData)
    }
  })
}
</script>

<template>
  <div class="default-dialog" :class="dialogType == 'ppt' ? 'ppt-ctr' : 'experience-ctr'"
    v-if="dialogType == 'ppt' || dialogType == 'experience'">
    <el-dialog v-model="defaultDialogVisible" :close-on-click-modal="false" :title="dialogTitle" :show-close="true"
      @close="closeDialog" align-center>
      <div class="dialog-body" v-if="dialogType == 'ppt'">
        <div class="content-left">
          <div class="left-img-small" :class="{ 'left-img-large': index == 0 }"
            v-for="(item, index) in selePttData.imgList.slice(0, 4)" :key="index">
            <img class="left-img" :src="item.imgUrl" alt="" />
          </div>
        </div>
        <div class="content-right">
          <div class="template-list">
            <div class="template-item" v-for="(item, index) in TemplateImgList"
              :class="{ 'select-template': item.id == selePttData.id }" :key="index" @click="switchTemplate(item)">
              <img v-show="item.id == selePttData.id" class="select-img" src="../../../assets/select-template.png"
                alt="" />
              <div class="item-img">
                <img class="small-img" :src="item.imgList[0].imgUrl" alt="" />
              </div>
            </div>
          </div>
          <div>
            <el-button type="primary" class="submit-btn" @click="submitTemplate" :disabled="isClickSubmit">
              生成课件
            </el-button>
          </div>
        </div>
      </div>
      <div class="dialog-body-ex" v-if="dialogType == 'experience'">

        <div class="content-right">
          <div class="form-ctr">
            <el-form :model="membershipForm" ref="ruleFormRef" :rules="rules">
              <el-form-item required class="form-item-long" prop="code">
                <template v-slot:label>
                  <div class="label-ctr">
                    <span style="z-index: 200">激活码</span>
                    <div class="item-shadow"></div>
                  </div>
                </template>
                <el-input v-model="membershipForm.code" :placeholder="'请输入图书背后的激活码'" type="text" :validate-event="false"
                  :disabled="dialogTitle == '修改设置'" />
              </el-form-item>

              <el-form-item required class="form-item-long" prop="bookId">
                <template v-slot:label>
                  <div class="label-ctr">
                    <span style="z-index: 200">选择书籍</span>
                    <div class="item-shadow"></div>
                  </div>
                </template>
                <el-select v-model="membershipForm.bookId" placeholder="请选择书籍" :validate-event="false"
                  :empty-values="[null, undefined]" :value-on-clear="null" clearable filterable>
                  <el-option v-for="item in phaseList" :key="item.id" :label="item.bookName" :value="item.id" />
                </el-select>
              </el-form-item>
              <!-- <el-form-item required class="form-item-long" prop="subjectId">
                <template v-slot:label>
                  <span style="z-index: 200">学科</span>
                  <div class="item-shadow"></div>
                </template>
                <el-select v-model="membershipForm.subjectId" placeholder="请选择学科" :validate-event="false">
                  <el-option v-for="item in subjectList" :key="item.id" :label="item.dictName" :value="item.id" />
                </el-select>
              </el-form-item> -->
              <!-- <el-form-item required class="form-item-long" prop="bookId">
                <template v-slot:label>
                  <span style="z-index: 200">册别</span>
                  <div class="item-shadow"></div>
                </template>
                <el-select v-model="membershipForm.bookId" placeholder="请选择册别" :validate-event="false">
                  <el-option v-for="item in bookList" :key="item.id" :label="item.dictName" :value="item.id" />
                </el-select>
              </el-form-item> -->
              <el-form-item class="form-item-btn">
                <div class="test-tip">
                  点击确定后将不可更改，请仔细核对信息
                  <!-- <span class="footer-link" @click="gotoAgreeMentPage"> 服务协议</span>、
                  <span class="footer-link" @click="gotoAgreeMentPage">隐私政策</span> -->
                </div>
                <el-button type="primary" class="submit-btn test-btn" @click="submitMembershipForm(ruleFormRef)">
                  确定
                </el-button>
              </el-form-item>
            </el-form>
          </div>
          <div></div>
        </div>

      </div>
    </el-dialog>
  </div>
  <div class="login-dialog" v-else-if="dialogType == 'login'">
    <el-dialog v-model="loginDialogVisible" :close-on-click-modal="false" title="" :show-close="true"
      @close="closeDialog" align-center>
      <div class="login-ctr">
        <div class="login-title">
          {{ '微信扫码一键登录' }}
        </div>
        <div class="weixin-ctr">
          <div class="qrcode-ctr">
            <img class="qrcode-img" :src="qrcodeImg" alt="" />
          </div>
        </div>
        <div class="login-footer">
          欢迎使用核心素养教学活动与作业设计AI生成平台，您登录即同意
          <span class="footer-link" @click="gotoAgreeMentPage"> 服务协议</span>、
          <span class="footer-link" @click="gotoAgreeMentPage">隐私政策</span>
        </div>
      </div>
    </el-dialog>
  </div>
  <div class="feedback-dialog" v-else-if="dialogType == 'feedback'">
    <el-dialog v-model="feedbackDialogVisible" :close-on-click-modal="false" :title="dialogTitle" :show-close="true"
      @close="closeDialog" align-center>
      <div class="dialog-body-feedback">
        <div class="left-ctr">
          <div class="feedback-tip">
            为了更好地服务于您，我们诚挚邀请您抽出几分钟时间，与我们分享您的感受和建议。您的宝贵意见对我们至关重要，我们非常重视每一位用户的反馈。期待您的积极参与！立即开始吧！
          </div>
          <div class="feedback-item">
            <div class="item-title">
              <span class="important">* </span>
              <span class="title-name">您反馈的模块
                <span class="title-shadow"></span>
              </span>
              <span class="title-tip">（单选）</span>
            </div>
            <div class="item-content">
              <div class="content-radio" v-for="(item, index) in moduleDataList" :key="index"
                @click="switchModule(item)">
                <span class="radio-check" :class="{ 'select-radio': item.id == selectModuleData.id }">
                  <img class="check-icon" src="@/assets/radio-check-icon.png" alt="" />
                </span>
                <span class="radio-name" :class="{ 'short-name': item.name.length == 3 }">{{
      item.name
    }}</span>
              </div>
              <div class="error" v-show="isCheckForm && feedbackForm.moduleName == ''">
                请选择您反馈的模块
              </div>
            </div>
          </div>
          <div class="feedback-item">
            <div class="item-title">
              <span class="important">* </span>
              <span class="title-name">您遇到的问题
                <span class="title-shadow"></span>
              </span>
              <span class="title-tip">（多选）</span>
            </div>
            <div class="item-content">
              <div class="content-radio" v-for="(item, index) in selectModuleData.questions" :key="index"
                @click="selectQuestions(item)">
                <span class="check-box-check" :class="{ 'select-radio': feedbackForm.questions.includes(item.name) }">
                  <!--                  <span class="check-icon">-->
                  <!--                  </span>-->
                  <img class="check-icon" src="@/assets/radio-check-icon.png" alt="" />
                </span>
                <span class="radio-name">{{ item.name }}</span>
                <span class="radio-tip" v-show="feedbackForm.questions.includes('其他')">{{
      item.tip
    }}</span>
              </div>
              <div class="error" v-show="isCheckForm && feedbackForm.questions.length == 0">
                请选择您遇到的问题
              </div>
            </div>
          </div>
        </div>
        <div class="right-ctr">
          <div class="feedback-item">
            <div class="item-title">
              <span class="important" v-show="feedbackForm.questions.includes('其他')">* </span>

              <span class="title-name">问题与建议
                <span class="title-shadow"></span>
              </span>
            </div>
            <div class="item-content right-content">
              <el-input v-model="feedbackForm.detailedQuestion" show-word-limit style="width: 364px" :rows="2"
                type="textarea" placeholder="请留下您的宝贵建议！" />
              <div class="error" v-show="isCheckForm &&
      feedbackForm.questions.includes('其他') &&
      feedbackForm.detailedQuestion == ''
      ">
                请填写您的问题与建议
              </div>
            </div>
          </div>
          <div class="feedback-item">
            <div class="item-title">
              <span class="title-name">留下您的联系方式，我们会尽快与您联系
                <span class="title-shadow"></span>
              </span>
            </div>
            <div class="item-content right-content">
              <el-input v-model="feedbackForm.phone" style="width: 364px" placeholder="请留下您的联系方式" />
            </div>
          </div>
          <el-button type="primary" class="feedback-btn" @click="submitFeedback()">
            提交反馈
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<style scoped lang="scss">
.default-dialog.experience-ctr {
  :deep(.el-dialog) {
    width: 374px;
  }
}

.default-dialog {
  :deep(.el-dialog) {
    width: 865px;
    border-radius: 12px;
    box-shadow: 0 4px 10px 0 rgba(158, 172, 229, 0.3);
    padding: 0;
    background: #fff;

    .el-dialog__header {
      font-size: 18px;
      font-weight: bold;
      line-height: 26px;
      align-items: center;
      font-variation-settings: 'wght' 600;
      color: #040a39;
      // background: linear-gradient(90deg, #edf1ff 0%, rgba(213, 222, 252, 0.21) 100%);
      // background: url('@/assets/longDialog-header-bg.png') no-repeat;
      // background-size: cover;
      // -webkit-background-size: cover;
      border-radius: 16px 16px 0 0;
      height: 58px;
      display: flex;
      padding: 0 32px;
    }

    .el-dialog__headerbtn {
      height: 58px;
    }

    .el-dialog__body {
      font-size: 14px;
      font-weight: normal;
      display: flex;
      align-items: center;
    }
  }
}

.dialog-body {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  width: 100%;
  margin: 11px 18px 16px;
  padding: 14px 5px 21px 16px;
  background: #ffffff;
  border-radius: 12px;
}

.dialog-body-ex {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  width: 100%;
  padding: 0px 18px 20px 18px;
  border-radius: 12px;
}

.dialog-body-ex .content-left {
  width: 491px;
  height: 494px;
  border-radius: 12px;
  opacity: 1;
  background: #ffffff;
  padding: 12px;
}

.dialog-body-ex .content-right {
  // width: 322px;
  // background: #ffffff;
  // border-radius: 12px;
  // padding: 2px 16px 16px 17px;
}

.tip-text {
  padding: 4px;
  font-size: 12px;
  font-weight: normal;
  line-height: 24px;
  text-align: justify;
}

.form-ctr {
  :deep(.el-form) {
    display: flex;
    flex-wrap: wrap;

    .el-form-item__label {
      justify-content: flex-start;
      position: relative;
    }
  }

  :deep(.el-select) {
    width: 296px;
    margin-left: 6px;

    .el-select__wrapper {
      background: #f6f6fb;
      box-shadow: none;
      border-radius: 6px;
    }
  }

  :deep(.el-input) {
    width: 296px;
    margin-left: 6px;

    .el-input__wrapper {
      background: #f6f6fb;
      box-shadow: none;
      border-radius: 6px;
    }

    .el-input__count-inner {
      background: transparent !important;
    }

    .el-input__wrapper.is-focus {
      border: 1px solid #F95946;
      background: #ffffff;
    }
  }
}

// .form-item {
//   flex-direction: column;
//   width: 136px;
//   margin-bottom: 11px !important;
// }

.form-item-long {
  flex-direction: column;
  width: 100%;
  margin-bottom: 11px !important;
}

.form-item-btn {
  flex-direction: column;
  width: 100%;
  margin-bottom: 0 !important;
}

.label-ctr {
  display: inline-flex;
  width: fit-content;
  position: relative;
  z-index: 200;
  padding: 0 3px;
}

.item-shadow {
  //border-radius: 62px 0 2px 0;
  //opacity: 1;
  //height: 5px;
  //background: #dbdfff;
  //width: 29px;
  //bottom: 7px;
  //position: absolute;
  //left: 10px;

  border-radius: 62px 0 2px 0;
  opacity: 1;
  height: 5px;
  background: #dbdfff;
  width: 100%;
  bottom: 7px;
  position: absolute;
  left: 0;
  z-index: -1;
}

.small-shadow {
  width: 42px;
}

.middle-shadow {
  width: 55px;
}

.long-shadow {
  width: 118px;
}

.verificationCode-ctr {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.verificationCode-btn {
  width: 94px;
  height: 32px;
  border-radius: 69px;
  opacity: 1;

  box-sizing: border-box;
  border: 1px solid #F95946;
  font-size: 14px;
  font-weight: normal;
  color: #F95946;
}

.verificationCode-btn:hover {
  background: #fff1ef;
  color: #F95946;
  border: 1px solid #F95946;
}

.count-down {
  font-size: 14px;
  font-weight: normal;
  line-height: 24px;
  text-align: center;
  color: #F95946;
  width: 94px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.test-tip {
  font-size: 12px;
  font-weight: normal;
  line-height: normal;
  color: #909399;
  margin-left: 39px;
  margin-top: 17px;
}

.img-code {
  width: 100px;
  height: auto;
}

.imgCode-ctr {
  display: flex;
  line-height: 32px;
}

.check-btn {
  border: none !important;
}

.content-left {
  width: 491px;
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
}

.left-img-small {
  width: 159px;
  height: 96px;
  border-radius: 6px;
}

.left-img-large {
  width: 491px;
  height: 278px;
  border-radius: 6px;
}

.left-img {
  width: 100%;
  height: 100%;
  border-radius: 6px;
  border: 1px solid #efefef;
}

.content-right {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-left: 16px;
}

.template-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  height: 339px;
  overflow-y: auto;
  scrollbar-width: auto;
}

.template-list::-webkit-scrollbar {
  display: block !important;
}

.template-list::-webkit-scrollbar-button {
  display: block !important;
}

.template-list::-webkit-scrollbar {
  width: 6px;
}

.template-item {
  width: 142px;
  height: 80px;
  border-radius: 8px;
  position: relative;
}

.select-img {
  width: 142px;
  height: 80px;
  position: absolute;
  z-index: 10;
}

.item-img {
  width: 100%;
  height: 100%;
  border-radius: 8px;
  z-index: 100;
}

.small-img {
  border-radius: 8px;
  width: 100%;
  height: 100%;
}

.submit-btn {
  margin-top: 9px;
  width: 290px !important;
  height: 40px;
  border-radius: 69px;
  font-size: 14px;
  font-weight: bold;
  line-height: 24px;
  border: none !important;
  background: #F95946;
}

.submit-btn:hover {
  background: #ea422e
}


.test-btn {
  margin-top: 12px;
}

.dialog-footer {
  :deep(.el-button) {
    width: 60px;
    height: 32px;
    border-radius: 92px;
    font-size: 14px;
    font-weight: 500;
  }
}

.login-dialog {
  :deep(.el-dialog) {
    width: 458px;
    height: 459px;
    border-radius: 12px;
    box-shadow: 0 4px 10px 0 rgba(158, 172, 229, 0.3);
    padding: 18px;
    background: #f6f6fb;

    .el-dialog__body {
      background: #ffffff;
      width: 422px;
      height: 423px;
      border-radius: 12px;
    }

    .el-dialog__header {
      padding: 0;
    }

    .el-dialog__headerbtn {
      right: 21px;
      top: 18px;
    }
  }
}

.login-ctr {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding-top: 53px;
}

.login-title {
  font-size: 20px;
  font-weight: bold;
  line-height: normal;
  color: #040a39;
  margin-bottom: 32px;
}

.weixin-ctr {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.qrcode-ctr {
  width: 192px;
  height: 192px;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.12);
  border-radius: 12px;
}

.qrcode-img {
  border-radius: 12px;
}

.login-tip {
  font-size: 12px;
  font-weight: normal;
  line-height: normal;
  letter-spacing: 0;
  margin-top: 12px;
  margin-bottom: 27px;
  color: #909399;
}

.login-footer {
  width: 66%;
  text-align: center;
  margin-top: 32px;
  font-size: 12px;
  color: #909399;
}

.footer-link {
  color: #F95946;
}

.footer-link:hover {
  cursor: pointer;
}

.feedback-dialog {
  :deep(.el-dialog) {
    width: 865px;
    border-radius: 12px;
    box-shadow: 0 4px 10px 0 rgba(158, 172, 229, 0.3);
    padding: 0;
    background: #f6f6fb;

    .el-dialog__header {
      font-size: 18px;
      font-weight: 500;
      line-height: 24px;
      align-items: center;
      color: #040a39;
      background: linear-gradient(90deg, #edf1ff 0%, rgba(213, 222, 252, 0.21) 100%);
      background: url('@/assets/longDialog-header-bg.png') no-repeat;
      background-size: cover;
      -webkit-background-size: cover;
      border-radius: 16px 16px 0 0;
      height: 50px;
      display: flex;
      padding: 0 32px;
    }

    .el-dialog__headerbtn {
      height: 50px;
    }

    .el-dialog__body {
      font-size: 14px;
      font-weight: normal;
      display: flex;
      align-items: center;
    }
  }

  :deep(.el-textarea) {
    width: 364px;
    height: 152px;

    .el-textarea__inner {
      background: #f6f6fb;
      box-shadow: none;
      height: 152px;
      border-radius: 6px;
    }

    .el-input__count {
      background: transparent !important;
    }

    .el-textarea__inner.is-focus {
      border: 1px solid #FF2800;
      background: #ffffff;
    }
  }

  :deep(.el-input) {
    width: 364px;

    .el-input__wrapper {
      background: #f6f6fb;
      box-shadow: none;
      border-radius: 6px;
    }

    .el-input__count-inner {
      background: transparent !important;
    }

    .el-input__wrapper.is-focus {
      border: 1px solid #FF2800;
      background: #ffffff;
    }
  }
}

.dialog-body-feedback {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  width: 100%;
  height: 526px;
  padding: 16px 17px 16px 16px;
}

.left-ctr {
  width: 408px;
  height: 494px;
  background: #ffffff;
  border-radius: 12px;
}

.right-ctr {
  width: 408px;
  height: 494px;
  background: #ffffff;
  border-radius: 12px;
  padding: 16px 6px;
  position: relative;
}

.feedback-tip {
  width: 384px;
  height: 88px;
  border-radius: 8px;
  opacity: 1;
  background: rgba(72, 92, 236, 0.08);
  margin: 12px 12px 20px;
  padding: 8px;
  font-size: 12px;
  font-weight: normal;
  line-height: 24px;
  text-align: justify;
  color: #040a39;
}

.feedback-item {
  margin-left: 16px;
}

.item-title {
  font-size: 14px;
  font-weight: 350;
  line-height: normal;
  color: #4e5969;
}

.important {
  color: #fd1c1c;
}

.title-name {
  position: relative;
  z-index: 100;
}

.title-shadow {
  border-radius: 62px 0 2px 0;
  opacity: 1;
  height: 5px;
  background: #dbdfff;
  width: 100%;
  bottom: 0;
  position: absolute;
  left: -2px;
  z-index: -1;
}

.title-tip {
  color: #b1b3b8;
}

.item-content {
  display: flex;
  flex-wrap: wrap;
  /*gap: 12px 25px;*/
  margin-top: 11px;
  margin-left: 9px;
  margin-bottom: 21px;
  position: relative;
}

.right-content {
  margin-left: 0;
  margin-top: 12px;
}

.content-radio {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  height: 22px;
  margin-right: 25px;
  margin-bottom: 12px;
}

.radio-check {
  display: inline-block;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 1px solid #c9cdd4;
  margin-right: 8px;
  position: relative;
}

.check-box-check {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 1px solid #c9cdd4;
  margin-right: 8px;
  border-radius: 2px;
  position: relative;
}

.select-radio {
  color: #F95946;
  border: 1px solid #F95946;
  background-color: #F95946;
}

/*.check-icon{
  color: #fff;
  background: url('@/assets/radio-check-icon.png') no-repeat center center;
  background-size: 55% 55%;
  display: inline-block;
  width: 100%;
  height: 100%;
}*/
.check-icon {
  width: 10px;
  height: 8px;
  left: 50%;
  top: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.radio-name {
  line-height: 1;
}

.short-name {
  margin-right: 14px;
}

.radio-tip {
  color: #b1b3b8;
}

.feedback-btn {
  width: 364px;
  height: 40px;
  border-radius: 69px;
  font-size: 14px;
  font-weight: bold;
  line-height: 24px;
  margin-left: 16px;
  position: absolute;
  bottom: 16px;
  border: none !important;
}

.error {
  color: #f56c6c;
  position: absolute;
  bottom: -20px;
  font-size: 12px;
}
</style>

<style>
.custom-loading-svg .el-loading-spinner {
  height: 200px;
  width: 200px;
  background-repeat: no-repeat;
  background-image: url(/src/assets/loading.gif);
  background-size: 200px 200px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.custom-loading-svg .el-loading-spinner .circular {
  width: 92px;
  height: 72px;
  display: none;
}
</style>
